import React,{useState,useEffect} from 'react'
import { Link  } from 'react-router-dom';
import { IoIosSearch } from "react-icons/io";
import Popover from '../admin/shared/Popover';  
import Preview from './shared/Preview';
import axios from "axios";
import config from "../config";
import { PRINT_PRODUCT_QR } from '../common/constants';
import Pagination  from "../common/Pagination";

function QrList() { 
  const [itemsPerPage, setItemsPerPage] = useState(10); 
    const [searchTerm, setSearchTerm] = useState(''); 
    const [PopoverprevId, setPopoverprevId] = useState(null);
    const [selectedPopoverId, setSelectedPopoverId] = useState(false);
    const [sortConfig, setSortConfig] = useState({ key: 'productName', direction: 'ascending' });
    const [qrList, setQrListData] = useState([]);
    const [selectedQr, setSelectedQr] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const limit = 10; // Number of items per page
    useEffect(() => {
      // Fetch data from the API
    
      getQrs();
      
    
    
    }, [currentPage, limit]); // Empty dependency array means this effect runs only once on component mount

    const getQrs=()=>{
      axios.post(`${config.backendUrl}/admin/qr-get`,{params: {
        page: currentPage,
      
      },}, {
        headers: {
          'token': localStorage.getItem('token'), // Example authorization header
          'Content-Type': 'application/json', // Example content type header
          // Add more headers as needed
        }
        })
      .then(response => {
        // Handle response
        setQrListData(response.data.data);
        setTotalPages(Math.ceil(response.data.total_count / limit));
      })
      .catch(error => {
        // Handle error
        console.error('Error:', error);
      });
    }
    const handleOpenprevPopover = (id) => {
      setPopoverprevId(id);
    };
  
    const handleCloseprevPopover = () => {
      setPopoverprevId(null);
    };


 
  
    const handleClosePopover = () => {
      setSelectedPopoverId(false);
    };
   
    const handlePageChange = (newPage) => {
      setCurrentPage(newPage);
    };
    const handleSearchChange = (event) => {
      setSearchTerm(event.target.value);
    };
     const handlePrintQrs=(qrListId)=>{

     
      axios.post(PRINT_PRODUCT_QR,{'qr_list_id' : qrListId}, {
        headers: {
          'token': localStorage.getItem('token'), // Example authorization header
          'Content-Type': 'application/json', // Example content type header
          // Add more headers as needed
        }
        })
      .then(response => {
        // Handle response
     

       printImages(response.data.data);
      })
      .catch(error => {
        // Handle error
        console.error('Error:', error);
      });
     }

     const printImages = (images) => {

    };
  const sortItems = (key) => {
    let direction = 'ascending';
    if (sortConfig.key === key && sortConfig.direction === 'ascending') {
      direction = 'descending';
    }
    setSortConfig({ key, direction });
  };
 

    const filteredItems = searchTerm ? qrList.filter(item =>
      item.productName.toLowerCase().includes(searchTerm.toLowerCase()) ||      
      item.dateCreated.includes(searchTerm) || 
      (item.isRedeemed ? 'Yes' : 'No').toLowerCase().includes(searchTerm.toLowerCase()) ||
      (item.redeemedBy && item.redeemedBy.toLowerCase().includes(searchTerm.toLowerCase()))||
      item.rewardPoints.toString().includes(searchTerm)

    ) : qrList;

    const sortedFilteredItems = filteredItems.sort((a, b) => {
      if (a[sortConfig.key] < b[sortConfig.key]) {
        return sortConfig.direction === 'ascending' ? -1 : 1;
      }
      if (a[sortConfig.key] > b[sortConfig.key]) {
        return sortConfig.direction === 'ascending' ? 1 : -1;
      }
      return 0;
    });
  
 
    
  return (
    <> 
  
 
    <div className='flex justify-between items-center pt-[70px]'> 
      <div> 
        <h2> QR Batch List</h2>
        <div className='breadcrumbs'> <Link to="/admin/dashboard">Home</Link>{">"} QR Batch List </div>
      </div>
        <div className='flex gap-2 items-center'> 
        <div>
      
      </div> 
       {/** add qr generator button */}
       <div>
        <Link to="/admin/qrgenerate" > 
          <button    className='genreport-btn'>Generate QR</button>
        </Link>
      </div>
      <div className='flex gap-2 mob-wrap mob-alignfilters'> 
          <div className='flex table-search bg-white'>
          <input
              type="text"
              placeholder="Search"
              value={searchTerm}
              onChange={handleSearchChange}
            />
            <IoIosSearch />
          </div>
       
        </div>
    <div>
        
      </div> 
    
    </div>
</div>
    
    
    <div  className='whitebox'>
        


    <div>
      <table className='tablegrid table-auto w-full border-collapse border' width={"100%"}>
        <thead>
          <tr className='bg-gray-100 text-center'>
            
            <th className=" py-4 font-medium">S.No</th>
             <th className=" py-4 font-medium">Model</th>
            <th className=" py-4 font-medium">Product Name</th>
            <th className=" py-4 font-medium">Quantity</th>
            <th className=" py-4 font-medium">Reward Points</th>
            <th className=" py-4 font-medium">Location</th>
            <th className=" py-4 font-medium">Date Created</th>
           
            <th className=" py-4 font-medium">Print</th>
          </tr>
        </thead>
        <tbody>
          {qrList.map((item, index) => (
           <tr key={index} >
           <td className="py-4 font-medium"> {index + 1 + (currentPage - 1) * limit}</td>
           <td>{item.model_name}</td>
           <td>{item.product_name}</td>
           <td>{item.quantity}</td>
           <td>{item.reward_points}</td>
           <td>{item.location_name}</td>
           <td>{item.created}</td>
       
       
         
           <td className='redfont'><button    onClick={()=>handlePrintQrs(item.id)} ><a href={`/admin/print-qrs/${item.id}`} target="_blank" rel="noopener noreferrer">Print</a>
  </button></td>
         </tr>
          ))}
        </tbody>
      </table>

      <div className="flex justify-between">
          <div> </div>
          <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={handlePageChange}
             />

        </div>
      </div>

    </div>

    {PopoverprevId && (
          <Popover onClose={handleCloseprevPopover} isVisible={setPopoverprevId !== null}>
            <Preview></Preview>
          </Popover>
        )}
 
    
    </>
  )
}

export default QrList